export enum IdvNextAction {
    ContinuePolling = 'ContinuePolling',
    RetryCapture = 'RetryCapture',
    ShowSubmitted = 'ShowSubmitted',
    ExitFlow = 'ExitFlow',
}
